<template>
  <div>
    <div>
      <vs-table stripe :data="arregloPagos" class="mt-3" max-items="5" search pagination>
        <template slot="header">
          <div class="flex">
              <vs-chip>Cantidad: {{ arregloPagos.length }}</vs-chip>
          </div>
          <br>
        </template>
        <template slot="thead">
            <vs-th width="35%">Documento</vs-th>
            <vs-th width="15%">Contrato</vs-th>
            <vs-th width="30%">Detalle</vs-th>
            <vs-th width="30%">Acción</vs-th>
        </template>
        <template slot-scope="{data}">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <vs-td>#{{ tr.doc_codigo }}</vs-td>
              <div class="flex" v-if="tr.ifAntAprobado == 0">
                <p class="justify-center"><vs-alert v-if="tr.estado == 0" color="danger">⚠️ Pendiente de cerrar</vs-alert></p>
                <p class=""><vs-chip v-if="tr.estado == 1" color="success">Aprobado</vs-chip></p>
                <p class=""><vs-chip v-if="tr.estado == 2" color="danger">Anulado</vs-chip></p>
              </div>
              <div class="flex" v-if="tr.ifAntAprobado == 1">
                 <p class="justify-center"><vs-alert v-if="tr.estado == 0" color="danger">⚠️ Pendiente de cerrar</vs-alert></p>
              </div>
              <div :class="sendPedido.ifagregado_anticipo_aprobado == 0 || sendPedido.ifagregado_anticipo_aprobado == 2  ?  'mt-2 bg-warning' :  'mt-2 bg-success'" v-if="tr.ifAntAprobado == 1"  style="color:white;padding:5px;border-radius: 10px;">
                <p class="font-bold mt-2">Anticipo Pedido:</p>
                <small v-if="sendPedido.ifagregado_anticipo_aprobado == 0">Sin aprobar</small>
                <small v-if="sendPedido.ifagregado_anticipo_aprobado == 1 && sendPedido.anticipo_aprobado > 0">Anticipo aprobado por admin facturador</small>
                <small v-if="sendPedido.ifagregado_anticipo_aprobado == 2" class="font-bold">!Anticipo solicitado a gerencia ${{ sendPedido.anticipo_solicitud_for_gerencia }}</small>
                <small v-if="sendPedido.ifagregado_anticipo_aprobado == 3"><b>ANTICIPO APROBADO POR GERENCIA <span class="text-success">$ {{ sendPedido.anticipo_aprobado_gerencia }}</span></b></small>
                <small v-if="sendPedido.ifagregado_anticipo_aprobado == 4" class="text-danger">Anticipo solicitado: rechazado</small>
                <small v-if="sendPedido.ifagregado_anticipo_aprobado == 5" class="text-success">Gerencia aprueba anticipo sugerido</small>
              </div>
              <p  class="mt-3" style="font-weight:bold;">Doc valor:  <span  class="text-success font-bold">{{ data[indextr].doc_valor | filtrarDecimal }}</span></p>
              <p style="font-weight:bold;">Tipo de pago:</p>
              <span>{{ tr.tipo_pagos.nombre }} <b v-if="tr.mostrar_reporte == 1" class="text-warning"> (Se muestra en el reporte )</b></span>
              <p style="font-weight:bold;">Forma de pago:</p>
              <p>{{ tr.forma_pagos.tip_pag_nombre }}</p>
              <div v-if="tr.unicoEvidencia == 0 && tr.tipo_pago_id!=4">
                <p style="font-weight:bold;" >Doc. Número:</p>
                <span>{{ data[indextr].doc_numero }}</span>
              </div>
              <p style="font-weight:bold;" v-if="tr.tipo_pago_id!=4">Doc. Nombre:</p>
              <span v-if="tr.tipo_pago_id!=4">{{ data[indextr].doc_nombre }}</span>
              <p style="font-weight:bold;" v-if="tr.tipo_pago_id!=4">Doc. Apellidos:</p>
              <span v-if="tr.tipo_pago_id!=4">{{ data[indextr].doc_apellidos }}</span>
              <!-- <p style="font-weight:bold;">Doc. Ci:</p>
              <span>{{ data[indextr].doc_ci }}</span> -->
              <p style="font-weight:bold;" v-if="tr.tipo_pago_id!=4">Doc. Institución:</p>
              <span v-if="tr.tipo_pago_id!=4">{{ data[indextr].doc_institucion }}</span>
              <p v-if="tr.tipo_pago_id!=4" style="font-weight:bold;">Doc. Tipo:</p>
              <span v-if="tr.tipo_pago_id!=4">{{ data[indextr].doc_tipo }}</span>
              <p style="font-weight:bold;">Doc. Fecha:</p>
              <span>{{ data[indextr].doc_fecha }}</span>
              <div v-if="tr.unicoEvidencia == 0 && tr.tipo_pago_id!=4">
                <p v-if="!tr.archivo">
                  <b class="text-danger"> Solicitud de evidencias: No subida </b>
                  </p>
                  <p v-else class="imagen" @click="openDocument(tr)">
                      <b> Evidencia:
                          <!--PDF-->
                          <ion-icon v-if="tr.archivo.substr(-3) == 'pdf'" style="font-size:20px;color:green;position:relative;top:5px;" name="document-outline"></ion-icon>
                          <!--IMAGE-->
                          <ion-icon v-else style="font-size:20px;color:green;position:relative;top:5px;" name="camera-outline"></ion-icon>
                      </b>
                  </p>
              </div>
          </vs-td>
          <vs-td>
            <b>Observación:</b>
            <p> {{ tr.doc_observacion }}</p>
            <b>Contrato:</b>
            {{ tr.ven_codigo }}
            <div v-if="tr.pedido_pagos_hijo.length">
              <vs-collapse accordion >
                <vs-collapse-item  style="position:relative;left:-50px;">
                  <div slot="header">
                    <p class="font-bold"> Ver varias Evidencias </p>
                  </div>
                  <vs-row>
                    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" vs-sm = "12" vs-xs="12" >
                      <vs-card>
                        <div class="header">
                          <p style="font-weight: bold;">Varias Documentos </p>
                          <table class="tabla">
                              <tr>
                                <th class="th1">Valor</th>
                                <th class="th1">Num. Documento</th>
                                <th class="th1">Evidencia</th>
                              </tr>
                              <tr v-for="(item,key) in tr.pedido_pagos_hijo" :key="key">
                                <td class="td1">{{  item.valor }}</td>
                                <td class="td1">{{ item.codigo }}</td>
                                <td class="td1">
                                  <p v-if="!item.archivo">
                                    <b class="text-danger"> Solicitud de evidencias: No subida </b>
                                    </p>
                                    <p v-else class="imagen" @click="openDocument(item)">
                                        <b> Evidencia:
                                            <!--PDF-->
                                            <ion-icon v-if="item.archivo.substr(-3) == 'pdf'" style="font-size:20px;color:green;position:relative;top:5px;" name="document-outline"></ion-icon>
                                            <!--IMAGE-->
                                            <ion-icon v-else style="font-size:20px;color:green;position:relative;top:5px;" name="camera-outline"></ion-icon>
                                        </b>
                                    </p>
                                </td>
                              </tr>
                          </table>
                        </div>
                      </vs-card>
                    </vs-col>
                  </vs-row>
                </vs-collapse-item>
                </vs-collapse>
            </div>
          </vs-td>
          <vs-td>
            <div v-if="tr.detalle_pago.length > 0">
              <!-- <div v-if="tr.tipo_pago_id == 4">
                <p class="text-danger">Estos detalles de pagos de tipo <b>convenio</b> no serán tomados en cuenta en el reporte solo los del módulo <b>Configuracion Convenios</b> boton <b>Detalle pagos</b></p>
              </div> -->
              <p  class="text-center"><b>Detalles de pago:</b></p>
              <div class="mt-2">
                <p><span class="font-medium">Total detalle Pagos:</span> {{ tr.totalDetallePago }}</p>
                <p class="text-danger" v-if="tr.totalDetallePago > tr.doc_valor"> <i class="fa-solid fa-triangle-exclamation"></i> Está superando el valor principal</p>
                <p class="text-danger" v-if="tr.totalDetallePago < tr.doc_valor"><i class="fa-solid fa-triangle-exclamation"></i> Es menor que el valor principal</p>
              </div>
              <div class="overflow-y-auto h-40 bg-white border rounded p-4 shadow-sm">
                <ul v-for="(item, key) in tr.detalle_pago" :key="key" class="mb-3 last:mb-0 border-b pb-2 last:border-b-0">
                  <li><span class="font-semibold text-gray-700">Valor:</span> <span class="text-gray-900"> {{ item.valor }}</span></li>
                  <li><span class="font-semibold text-gray-700">Descripción:</span> <span class="text-gray-900"> {{ item.descripcion }}</span></li>
                </ul>
              </div>
            </div>
          </vs-td>
          <vs-td align="center">
            <vs-dropdown vs-custom-content vs-trigger-click v-if="userAdminFacturador || userRoot || (userFacturador && tr.estado == 0) && tr.tipo_pago_id!=4">
              <vs-button class="a-icons" href.prevent icon="more_vert" type="border" v-if="tr.tipo_pago_id!=4"></vs-button>
              <vs-dropdown-menu style="width: 320px;" class="cursor">
                <!--ABIERTO-->
                <div v-if="tr.estado == 0">
                  <!--Aprobar anticipo solicitado-->
                  <vs-dropdown-item v-if="(userAdminFacturador || userRoot) && tr.ifAntAprobado == 1">
                    <vs-button color="primary" type="line" @click="id=tr.doc_codigo;ObjectSelect=tr;popupConfirmAnticipoAprobado=true;" icon-pack="feather" icon="icon-info" class="w-full">{{ sendPedido.ifagregado_anticipo_aprobado == 0 ? 'Aprobar Anticipo solicitado' : 'Cambiar Anticipo solicitado' }} </vs-button>
                  </vs-dropdown-item>
                  <vs-dropdown-item>
                    <vs-button color="success" @click="id=tr.doc_codigo;ObjectSelect=tr;openConfirmAprobarPago(tr);" type="line" icon-pack="feather" icon="icon-check"  class="w-full" >Cerrar Pago</vs-button>
                  </vs-dropdown-item>
                  <vs-dropdown-item>
                    <vs-button color="warning" type="line" @click="id=tr.doc_codigo;ObjectSelect=tr;$emit('showCreate',1,tr);" icon-pack="feather" icon="icon-edit"  class="w-full" >Editar Pago</vs-button>
                  </vs-dropdown-item>
                </div>
                <!--CERRADO-->
                <div v-if="tr.estado == 1">
                  <!--Reabrir pago-->
                  <vs-dropdown-item>
                    <vs-button color="primary" v-if="userAdminFacturador || userRoot"  icon-pack="feather" icon="icon-settings" type="line" class="w-full"  @click="ObjectSelect=tr;confirmReAbriPago(tr)">Reabrir Pago</vs-button>
                    <!-- <vs-button color="primary" v-if="userRoot"  icon-pack="feather" icon="icon-settings" type="line" class="w-full"  @click="ObjectSelect=tr;confirmReAbriPago(tr)">Reabrir Pago</vs-button> -->
                  </vs-dropdown-item>
                </div>
                <!--Eliminar Pago-->
                <vs-dropdown-item v-if="tr.estado == 0 || userRoot">
                  <vs-button color="danger"  type="line" icon-pack="feather" icon="icon-x" class="w-full" @click="ObjectSelect=tr;openConfirmEliminarPago(tr)">Eliminar Pago</vs-button>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
            <p class="mt-3"></p>
            <div v-if="tr.fecha_cierre">
              <b>Fecha último cierre:</b>
              <p>{{ tr.fecha_cierre }}</p>
            </div>
            <div v-if="tr.user_cierre">
              <b>Responsable:</b>
              <p>{{ tr.user_cierre.nombres }} {{ tr.user_cierre.apellidos}}</p>
            </div>
          </vs-td>
        </vs-tr>
        </template>
      </vs-table>
    </div>
    <!---MODALES-->
    <!--MODAL PARA APROBAR EL ANTICIPO APROBADO-->
    <vs-popup classContent="popup-example" title="Aprobar Anticipo del pedido" :active.sync="popupConfirmAnticipoAprobado">
      <AprobarAnticipoAprobadoVue v-if="popupConfirmAnticipoAprobado" :sendPedido="sendPedido" :usuario="usuario" :userRoot="Boolean(userRoot)" @changeHandle="changeHandle"/>
    </vs-popup>
  </div>
</template>
<script>
import axios from 'axios'
const AprobarAnticipoAprobadoVue = () => import('./components/AprobarAnticipoAprobado.vue')
const Pagos2DetallesPagoVue      = () => import('./components/Pagos2DetallesPago.vue')
import {
    mapState
} from "vuex";
export default {
  components:{
    AprobarAnticipoAprobadoVue,
    Pagos2DetallesPagoVue,
  },
  data() {
    return{
      ObjectSelect:'',
      popupConfirmAnticipoAprobado:false,
    }
  },
  // inject: ['getSendPedido'],
  // computed: {
  //   sendPedido(){ return this.getSendPedido(); }
  // },
  computed: {
    ...mapState(['userRoot', 'userAsesor', 'userFacturador', 'userAdminFacturador']),
  },
  props:{
    arregloPagos:{
      type:Array,
      default:function(){
        return []
      }
    },
    sendPedido:{
      type:Object,
      default:function(){
        return {}
      }
    },
    usuario:{
      type:Object,
      default:function(){
        return{}
      }
    },
  },
  watch:{
    arregloPagos(results){
      this.arregloPagos = results
    },
    sendPedido(results){
      this.sendPedido = results
    }
  },
  mounted(){
    let me  = this
  },
  methods:{
    rechargePedido(e){
      let me = this
      me.$emit('rechargePedido',e)
    },
    changeHandle(e){
      let me = this
      if(e == 0) { me.popupConfirmAnticipoAprobado = false; }
      if(e == 1) { me.popupConfirmAnticipoAprobado = false; me.rechargePedido();   me.$emit('rechargeValores',true) }
    },
    openDocument(tr){
      let me = this;
      let ruta = me.$data_url+'archivos/pedidos/pagos/'+tr.url
      window.open(ruta,'_blank')
    },
    openConfirmAprobarPago(tr){
      let me = this;
      //si es anticipo del pedido verificar que este aprobado por el facturador
      if(tr.ifAntAprobado == 1){
        if(me.sendPedido.ifagregado_anticipo_aprobado == 0){
          me.$vs.notify({
            text: 'El anticipo del pedido no esta aprobado por el facturador No puede cerrar el pago',
            color: 'warning',
            iconPack: 'feather',
            icon: 'icon-alert-triangle',
            time:6000,
          })
          return
        }
      }
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: `Confirmar`,
        acceptText:'Si, deseo aprobar el pago',
        cancelText:'Cancelar',
        text: 'Estás seguro de aprobar el pago?',
        accept:this.aprobarPago
      })
    },
    aprobarPago(){
      let me = this;
      let formData = new FormData();
      formData.append('aprobarPagoVerificacion',  'yes')
      formData.append('doc_codigo',               me.ObjectSelect.doc_codigo);
      formData.append('contrato',                 me.sendPedido.contrato_generado)
      formData.append('user_created',             me.usuario.idusuario);
      formData.append('periodo_id',               me.sendPedido.id_periodo)
      formData.append('institucion_id',           me.sendPedido.id_institucion)
      formData.append('id_pedido',                me.sendPedido.id_pedido)
      formData.append('valor',                    me.ObjectSelect.doc_valor)
      formData.append('tipo_pago_id',             me.ObjectSelect.tipo_pago_id)
      formData.append('doc_observacion',          me.ObjectSelect.doc_observacion)
      me.$vs.loading()
      this.$http.post(this.$server_url+'pedigo_Pagos', formData)
      .then(function (res) {
        me.$vs.loading.close()
        if(res.data.status == 0){
          me.$vs.notify({
            text: res.data.message,
            color: 'warning',
            iconPack: 'feather',
            icon: 'icon-alert-triangle',
            time:5000,
          })
          return
        }
        me.$vs.notify({
          text: res.data.message,
          color: 'success',
          iconPack: 'feather',
          icon: 'icon-alert-triangle'
        })
        me.$emit('rechargeValores',true)
      })
      .catch(function (error) {
        me.$vs.loading.close()
      })
    },
    openConfirmEliminarPago(){
        let me = this;
        if(me.ObjectSelect.ifAntAprobado == 1){
          this.$vs.dialog({
            type:'confirm',
            color: 'danger',
            title: `Confirmar`,
            acceptText:'Si, deseo eliminar el registro del pago',
            cancelText:'Cancelar',
            text: 'Estás seguro de eliminar el registro del pago?',
            accept:this.eliminarPagoAnticipo
          })
          return
        }
        const { doc_observacion ,tipo_pago_id } = me.ObjectSelect
        if((tipo_pago_id == 1 && doc_observacion &&  doc_observacion.toLowerCase().includes("deuda")) || tipo_pago_id == 6){
          this.$vs.dialog({
            type:'confirm',
            color: 'danger',
            title: `Confirmar`,
            acceptText:'Si, deseo eliminar el registro del pago',
            cancelText:'Cancelar',
            text: 'Estás seguro de eliminar el registro del pago?',
            accept:this.eliminarValorPagoDeuda
          })
          return
        }

        else{
          this.$vs.dialog({
            type:'confirm',
            color: 'danger',
            title: `Confirmar`,
            acceptText:'Si, deseo eliminar el registro del pago',
            cancelText:'Cancelar',
            text: 'Estás seguro de eliminar el registro del pago?',
            accept:this.eliminarValorPago
          })
        }
      },
      eliminarValorPago(){
        let me = this;
        let formData = new FormData()
        formData.append('eliminarRegistroPago',         "yes")
        formData.append('doc_codigo',                   me.ObjectSelect.doc_codigo)
        formData.append('id_pedido',                    me.sendPedido.id_pedido)
        formData.append('user_created',                 me.usuario.idusuario)
        me.$vs.loading()
        axios.post(this.$data_url + 'api/guardarDatosPedido', formData)
        .then(function (res) {
          me.$vs.loading.close()
          if(res.data.status == 0){
            me.$vs.notify({
            text:res.data.message,
            color:'warning',
            iconPack: 'feather',
            icon:'icon-check',
            time:5000
            })
            return
          }
          me.$vs.notify({
          text:"Se elimino correctamente",
          color:'success',
          iconPack: 'feather',
          icon:'icon-check'})
          me.setHistoricoPagoEliminado()
          // me.$emit('rechargeValores',true)
        })
        .catch(function (error) {
            me.$vs.loading.close()
        })
      },
      setHistoricoPagoEliminado(){
        let me = this
        let formData = new FormData()
        formData.append('eliminarPagoNormal',       "yes")
        formData.append('doc_codigo',                me.ObjectSelect.doc_codigo)
        formData.append('id_pedido',                 me.sendPedido.id_pedido)
        formData.append('user_created',              me.usuario.idusuario)
        formData.append('old_values',                JSON.stringify(me.ObjectSelect))
        formData.append('ven_codigo',                me.ObjectSelect.ven_codigo)
        formData.append('periodo_id',                me.ObjectSelect.periodo_id)
        formData.append('institucion_id',            me.ObjectSelect.institucion_id)
        formData.append('id_pedido',                 me.ObjectSelect.id_pedido)
        formData.append('tipo_pago_id',              me.ObjectSelect.tipo_pago_id)
        formData.append('forma_pago_id',             me.ObjectSelect.forma_pago_id)
        formData.append('doc_observacion',           me.ObjectSelect.doc_observacion)
        this.$http.post(this.$server_url+'eliminarPagos', formData)
        .then(function (res) {
          me.$emit('rechargeValores',true)
        })
        .catch(function (error) {})
      },
      eliminarPagoAnticipo(){
        let me = this
        let formData = new FormData()
        formData.append('eliminarPagoAnticipo',      "yes")
        formData.append('doc_codigo',                me.ObjectSelect.doc_codigo)
        formData.append('id_pedido',                 me.sendPedido.id_pedido)
        formData.append('user_created',              me.usuario.idusuario)
        me.$vs.loading()
        this.$http.post(this.$server_url+'eliminarPagos', formData)
        .then(function (res) {
          me.$vs.loading.close()
          me.$vs.notify({
          text:"Se elimino correctamente",
          color:'success',
          iconPack: 'feather',
          icon:'icon-check'})
          me.$emit('rechargeValores',true)
        })
        .catch(function (error) {})
      },
      eliminarValorPagoDeuda(){
        let me = this
        let formData = new FormData()
        formData.append('eliminarPagoDeuda',         "yes")
        formData.append('doc_codigo',                me.ObjectSelect.doc_codigo)
        formData.append('id_pedido',                 me.sendPedido.id_pedido)
        formData.append('doc_valor',                 me.ObjectSelect.doc_valor)
        formData.append('user_created',              me.usuario.idusuario)
        me.$vs.loading()
        this.$http.post(this.$server_url+'eliminarPagos', formData)
        .then(function (res) {
          me.$vs.loading.close()
          me.$vs.notify({
          text:"Se elimino correctamente",
          color:'success',
          iconPack: 'feather',
          icon:'icon-check'})
          me.$emit('rechargeValores',true)
        })
        .catch(function (error) {})
      },
      confirmReAbriPago(){
        let me = this
        this.$vs.dialog({
          type:'confirm',
          color: 'danger',
          title: `Confirmar`,
          acceptText:'Si, deseo reabrir el pago',
          cancelText:'Cancelar',
          text: 'Estás seguro de reabrir el pago?',
          accept:this.reAbriPago
        })
      },
      reAbriPago(){
        let me = this
        let formData = new FormData()
        formData.append('reabrirPagos',        "yes")
        formData.append('id_pedido',           me.sendPedido.id_pedido)
        formData.append('doc_codigo',          me.ObjectSelect.doc_codigo)
        formData.append('user_created',        me.usuario.idusuario)
        formData.append('tipo_pago_id',        me.ObjectSelect.tipo_pago_id)
        formData.append('forma_pago_id',       me.ObjectSelect.forma_pago_id)
        formData.append('doc_observacion',     me.ObjectSelect.doc_observacion)
        me.$vs.loading()
        this.$http.post(this.$server_url+'pedigo_Pagos', formData)
        .then(function (res) {
          me.$vs.loading.close()
          if(res.data.status == 0){
            me.$vs.notify({
            text:res.data.message,
            color:'warning',
            iconPack: 'feather',
            icon:'icon-check',
            time:5000
            })
            return
          }
          me.$vs.notify({
          text:"Se reabrio correctamente",
          color:'success',
          iconPack: 'feather',
          icon:'icon-check'})
          me.$emit('rechargeValores',true)
        })
        .catch(function (error) {})
      }
  }
}
</script>

